import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { InstanceInterface } from "../../utility/interface/api/instances/get-instance-res";

const initialState: InstanceInterface = {
  instance_id: 0,
  host_id: 0,
  product_name: "",
  price: 0,
  gpu_available: 0,
  time_consumed: 0,
  service_url: "",
  ssh_url: "",
  user_id: 0,
  public_key: "",
};

export const instanceSlice = createSlice({
  name: "instance",
  initialState,
  reducers: {
    chooseInstance: (state, action: PayloadAction<InstanceInterface>) => {
      return action.payload;
    },
    updatePublicKey: (state, action: PayloadAction<any>) => {
      return { ...state, public_key: action.payload };
    },
    removeInstance: (state) => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { chooseInstance, updatePublicKey, removeInstance } =
  instanceSlice.actions;

export default instanceSlice.reducer;
